import React from 'react'
import { Box, LinearProgress } from '@mui/material'

import Typography from '../Typography'

import './BranchingProcessProgress.scss'

export interface BranchingProcessProgressProps {
  completed: number
  total: number
  currentStepName: string
}

const BranchingProcessProgress: React.FC<BranchingProcessProgressProps> = ({
  completed,
  total,
  currentStepName,
}) => {
  if (total <= 0) {
    return (
      <Typography variant='caption' color='textSecondary'>
        Status not available
      </Typography>
    )
  }

  const isComplete = completed >= total
  const percent = Math.min((completed / total) * 100, 100)
  const summary = isComplete ? 'All stages complete' : currentStepName || `Step ${completed + 1}`

  return (
    <Box className='branching-process-progress'>
      <Typography variant='body1' color='textPrimary'>
        {summary}
      </Typography>
      <Typography variant='body2' color='textSecondary'>
        {completed} stage{completed !== 1 ? 's' : ''} complete
      </Typography>
      <LinearProgress
        variant='determinate'
        value={percent}
        className={`branching-process-progress__bar${isComplete ? ' branching-process-progress__bar--complete' : ''}`}
      />
    </Box>
  )
}

export default BranchingProcessProgress
